import { render, staticRenderFns } from "./xboot-components.vue?vue&type=template&id=adbeee08&"
import script from "./xboot-components.vue?vue&type=script&lang=js&"
export * from "./xboot-components.vue?vue&type=script&lang=js&"
import style0 from "./xboot-components.vue?vue&type=style&index=0&id=adbeee08&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports